import React, { useEffect } from "react";
import { Backtotop, Floatinmenu, Underline, ContentCard } from "../../widgets";
import { RadialMenu } from "../../components";
import { librarymenu } from "../../constants/library";
import { FaBook } from "react-icons/fa";
import "./Library.css";
import "../Library/E_resources_and_journals.css";
export default function E_resources_and_journals() {
  useEffect(() => {
    document.title = "ACCET-Library | E-resources and Journals";
  }, []);

  return (
    <>
      <div className="librarypage">
        <div className="librarybg">
          <div className="libraryheading">Library</div>
          <div className="library_sub_heading">E-Resources and journals</div>
        </div>
      </div>
      <section className="librarydark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaBook} head="Menu" links={librarymenu} />
        </div>
        <RadialMenu menu_links={librarymenu} />
        <Underline heading="E-Resources and Journals"></Underline>
        <div className="contents-of-e-resources">
          <ContentCard
            heading="MAT Journals"
            view="http://www.matjournals.com"
          />
          <ContentCard
            heading="STM Journals"
            view="http://www.stmjournals.com"
          />
          <ContentCard
            heading="ICTACT Journals"
            view="http://www.ictactjournals.in"
          />
          <ContentCard
            heading="Pearson E-Books"
            view="http://ebookcentral.proquest.com/lib/accetkaraikudi"
          />
          <ContentCard
            heading="Springer E-Books"
            view="http://link.springer.com"
          />
          <ContentCard
            heading="DELNET Membership"
            view="http://delnet.in"
            extradetails={{
              detail1: "login : tnaccet",
              detail2: "password: accet5069",
            }}
          />
          <ContentCard
            heading="ONOS (One Nation One Subscription)"
            view="http://www.onos.gov.in"
          />
        </div>
      </section>
      <Backtotop />
    </>
  );
}
